// extracted by mini-css-extract-plugin
export default {"generatePDF":"generatePDF_generatePDF__tdakv","infoSection":"generatePDF_infoSection__+lPrL","shopInfo":"generatePDF_shopInfo__wWR9v","details":"generatePDF_details__pGF7a"};